import { isNativePlatform } from './platform'

/**
 * The Coupon tab is deliberately app-only: the offers are there to give people a reason to install
 * the app, and showing the same codes on the web would remove that reason.
 *
 * Flip this to true to open it to the web as well — it is the only change needed; the backend
 * already serves the list to anyone entitled to it, and hiding the entry points is all this does.
 */
export const COUPONS_ON_WEB = false

/** Whether to offer the Coupon section at all in this build. */
export function couponsVisible(): boolean {
  return COUPONS_ON_WEB || isNativePlatform()
}
